const allowedDomains = [ "staging.willowlife.co.uk", "localhost", "almostalldigital.co.uk" ];
let hostDomain = "book.willowlife.co.uk";
if(allowedDomains.indexOf(window.location.hostname) >= 0) {
    hostDomain = window.location.host;
}

export default {
    willowApiKey: 'sHGWhRS8Gr2Z4H57xQBmukBuLjakpEJ2',
    shiftTimes: {
        early: { starts: 6, ends: 12 },
        afternoon: { starts: 12, ends: 17 }, 
        late: { starts: 17, ends: 23 },
    },
    hostDomain
};
